// Interface for JSON structure
export interface ISkill {
	name: string;
	rating: string;
	description: string;
	subSkills?: ISkill[];
}

export interface ICategory {
	name: string;
	skills: ISkill[];
}

export interface ISkillData {
	categories: ICategory[];
}

export interface SkillRating {
	title: string;
	description: string;
	tooltip: string;
}

export const skillRatings: { [key: string]: SkillRating } = {
	A: {
		title: "Highly Proficient",
		description: "I possess an advanced and thorough understanding of this technology. My experience enables me to work efficiently and confidently in various complex scenarios. I have a deep grasp of the core concepts and can implement solutions with a high degree of precision and reliability. I consistently produce high-quality results and can provide guidance or mentorship on this subject.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},
	B: {
		title: "Proficient",
		description: "I have a solid working knowledge of this technology, allowing me to handle most tasks independently and efficiently. While not yet at an expert level, I am confident in my ability to solve problems and contribute meaningfully. I can work with this skill without significant oversight and can produce well-structured, reliable solutions.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},
	C: {
		title: "Competent",
		description: "I have a good grasp of the basics and can apply this technology to routine tasks effectively. Though I may occasionally need to refer to documentation or seek guidance on more complex matters, I am able to work with a reasonable degree of independence. I deliver reliable results in familiar situations but may require additional time for more challenging tasks.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},
	D: {
		title: "Basic Familiarity",
		description: "I have some knowledge of this technology but only at a foundational level. I can handle basic tasks, but my experience is limited, and I would need support for more advanced work. My use of this skill is generally limited to straightforward or well-documented scenarios, and I may rely on external resources frequently.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},
	E: {
		title: "Limited Experience",
		description: "My exposure to this technology is minimal. I understand only the fundamental concepts and can perform very basic operations. However, I would need significant guidance to handle anything beyond the most elementary tasks, as I have not had much practical experience with this skill.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},
	/*F: {
		title: "Not Applicable",
		description: "I have little to no experience with this technology. It is not an area of focus or expertise for me, and I am not in a position to apply it meaningfully in any professional context.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	},*/
	"?": {
		title: "To rate",
		description: "This skill is yet to be rated. I have not yet determined my proficiency level in this area, or I may need to revisit it to provide an accurate assessment.",
		get tooltip() {
			return `<p><strong>${this.title}</strong></p><p>${this.description}</p>`;
		}
	}
};

